/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-06-18 10:15:54
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-07-17 10:20:52
 * @FilePath: /qd-yunjing-web/src/router/modules/system.ts
 * @Description: 这是默认设置,请设置`customMade
 */
import { RouteRecordRaw } from 'vue-router';

import Layout from '@/layouts/index.vue';

export const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/system',
    name: 'system-root',
    component: Layout,
    meta: {
      authCodes: ['SYSTEM'],
      title: '配置',
    },
    children: [
      {
        path: '/system/device/bianyuan',
        name: 'system-ibms-config',
        meta: {
          authCodes: ['IBMS_CONFIG'],
          title: '运行配置',
          activeMenu: '/safety',
        },
        children: [
          {
            path: '/system/device/bianyuan',
            name: 'system-device-bianyuan',
            component: () => import('@/views/system/ibms-config/bianyuan.vue'),
            meta: {
              authCodes: ['EDGE_MANAGEMENT'],
              title: '边缘管理',
              activeMenu: '/system',
            },
          },
          {
            path: '/system/device/tool',
            name: 'system-device-tool',
            component: () => import('@/views/system/ibms-config/tool.vue'),
            meta: {
              authCodes: ['IBMS_DEBUG_TOOL'],
              title: '调试工具',
              activeMenu: '/system',
            },
          },
          {
            path: '/system/device/log',
            name: 'system-device-log',
            component: () => import('@/views/system/ibms-config/log.vue'),
            meta: {
              authCodes: ['IBMS_OPERATION_LOG'],
              title: '操作日志',
              activeMenu: '/system',
            },
          },
          {
            path: '/system/device/config',
            name: 'device-config-index',
            component: () => import('@/views/system/ibms-config/device.vue'),
            meta: {
              authCodes: ['DEVICE_DETECTION_CONFIG'],
              title: '设备监控配置',
              activeMenu: '/system',
            },
          },
          {
            path: '/system/device/area',
            name: 'system-device-area',
            component: () => import('@/views/system/ibms-config/area.vue'),
            meta: {
              authCodes: ['IBMS_CONFIG'],
              title: '重庆智慧小区',
              activeMenu: '/system',
            },
          }, {
            path: '/system/device/light',
            name: 'system-device-light',
            component: () => import('@/views/system/ibms-config/light.vue'),
            meta: {
              authCodes: ['SMART_LIGHTING'],
              title: '智慧照明',
              activeMenu: '/system',
            },
          }

        ],
      },
      {
        path: '/system/energy',
        name: 'system-energy-index',
        component: () => import('@/views/system/energy/index.vue'),
        meta: {
          authCodes: ['CONSUMPTION_CONFIG'],
          title: '能耗配置',
          activeMenu: '/system',
        },
      },
      {
        path: '/system/general',
        name: 'system-general-index',
        component: () => import('@/views/system/general/index.vue'),
        meta: {
          authCodes: ['TRANSIT_CONFIG'],
          title: '通行配置',
          activeMenu: '/system',
        },
      },
      {
        path: '/system/operator/index',
        name: 'operator-index',
        component: () => import('@/views/system/operator/index.vue'),
        meta: {
          authCodes: ['PROJECT_INFO'],
          title: '运维工具',
          activeMenu: '/system',
        },
      },
      {
        path: '/system/project/index',
        name: 'operator-project-index',
        component: () => import('@/views/system/project/index.vue'),
        meta: {
          keepAlive: true,
          authCodes: ['PROJECT_INFO'],
          title: '项目管理',
          activeMenu: '/system',
        },
      },
      {
        path: '/system/project/detail/index',
        name: 'operator-project-detail-index',
        component: () => import('@/views/system/project/project-detail/index.vue'),
        meta: {
          keepAlive: true,
          authCodes: ['PROJECT_INFO'],
          title: '项目详情',
          activeMenu: '/system',
          selectProjectDisabled: true,
        },
      },
      {
        path: '/system/overall-device-manage',
        name: 'overall-device-manage-index',
        meta: {
          authCodes: ['DEVICE_MANAGE'],
          title: '设备管理',
          activeMenu: '/system',
          isTabsMenu: false,
        },
        children: [
          {
            path: '/system/overall-device-manage/dictionary',
            name: 'overall-device-manage-dictionary',
            component: () => import('@/views/system/device-manage/dictionary.vue'),
            meta: {
              authCodes: ['OVERALL_DEVICE_MANAGE_DICTIONARY'],
              title: '设备字典',
              activeMenu: '/system',
            },
          },
          {
            path: '/system/overall-device-manage/device-import-history',
            name: 'overall-device-manage-device-import-history',
            component: () => import('@/views/system/device-manage/device-import-history.vue'),
            meta: {
              authCodes: ['EQUIPMENT_IMPORT_RECORD'],
              title: '设备导入历史',
              activeMenu: '/system',
              projectCheckStrictly: true,
            },
          }
        ],
      },
      {
        path: '/system/operate-log',
        name: 'operate-log',
        meta: {
          authCodes: ['OPERATION_LOG_MANAGE'],
          title: '日志服务',
          activeMenu: '/system',
          isTabsMenu: false,
        },
        component: () => import('@/views/system/log-manage/index.vue'),
      },
      {
        path: '/system/menu-config',
        name: 'system-menu-config',
        component: () => import('@/views/system/menu-config/index.vue'),
        meta: {
          authCodes: ['MENU_CONFIG'],
          title: '菜单配置',
          activeMenu: '/system',
        },
      }
    ],
  }

];
